import React from "react";

export const IconOption1 = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4725 4.08146V4.08081L16.48 0.706055L14.5083 4.08146H19.4725Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.53662 5.4502L10.0466 15.7855L12.5572 5.4502H7.53662Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.92529 4.08221H12.1477V4.08155L10.0028 0.82959L7.92529 4.08155V4.08221Z"
        fill="#F2F2F2"
      />
      <path
        d="M13.3375 3.55323L15.233 0.30957H11.1978L13.3369 3.55323H13.3375Z"
        fill="#F2F2F2"
      />
      <path
        d="M8.8134 0.30957H4.86182L6.74983 3.53914L8.8134 0.30957Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.61259 0.706055L0.620117 4.08081V4.08146H5.58546L3.61259 0.706055Z"
        fill="#F2F2F2"
      />
      <path
        d="M0.523926 5.4502L8.72007 15.6231L8.72062 15.6243L6.24958 5.4502H0.523926Z"
        fill="#F2F2F2"
      />
      <path
        d="M13.8459 5.4502L11.3755 15.6243L11.376 15.6231L19.5716 5.4502H13.8459Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
